import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import useViewPortWidth from "src/utils/use-viewport-width";
import FreeTrialLock from "src/components/FreeTrialLock";
import { useFreeTrial } from "src/free-trial/helpers";
import { useFreeTrialToast } from "src/store/hooks/useFreeTrialToast";
import { useIntl } from "react-intl";

const RedesignLifeButton: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { viewPortWidth } = useViewPortWidth();

  // Enable hover effects on devices that support hover (desktop and tablets)
  const enableHoverEffect = viewPortWidth >= 768;
  const { isTrialUser } = useFreeTrial(0);
  const { showFreeTrialToast } = useFreeTrialToast();
  const intl = useIntl();

  return (
    <FreeTrialLock
      isLocked={isTrialUser}
      isRedesignYourLifeBtn
      onClick={() => {
        showFreeTrialToast({
          message: intl.formatMessage({
            id: "freeTrial.upgradeMessage",
          }),
          route: "/subscription",
        });
      }}
    >
      <button
        style={{
          position: "relative",
          zIndex: 10,
          outline: "none",
          border: "none",
          background: "none",
          padding: 0,
          margin: 0,
          WebkitTapHighlightColor: "transparent",
          width: viewPortWidth >= 768 ? "120px" : "40px", // Fixed width to prevent layout shift
          display: "flex",
          justifyContent: "flex-start",
        }}
        onClick={() => {
          const token = localStorage.getItem("__sal_auth");
          window.open(
            `https://redesign.smartsway.com/?__token=${token}`,
            "_blank"
          );
        }}
      >
        <Box
          onMouseEnter={() => enableHoverEffect && setIsHovered(true)}
          onMouseLeave={() => enableHoverEffect && setIsHovered(false)}
          style={{
            position: "relative",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            transition: "all 0.5s ease-in-out",
            width: isHovered ? "120px" : "40px",
            height: "40px",
            overflow: "hidden",
          }}
        >
          {/* Main Icon - Always visible */}
          <img
            src="/icone-main page.png"
            alt="Main page icon"
            style={{
              width: "40px",
              height: "40px",
              objectFit: "contain",
              filter: "brightness(1.1) contrast(1.1)",
              transition: "ease-in 0.5s",
              flexShrink: 0,
            }}
          />

          {/* Text/Logo that slides out from the right */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              transform: isHovered ? "translateX(4px)" : "translateX(-10px)",
              opacity: isHovered ? 1 : 0,
              transition: "ease-in 0.5s",
              whiteSpace: "nowrap",
            }}
          >
            <img
              src="/logo-Redesign-your-life-hover.png"
              alt="Redesign your life logo"
              style={{
                width: "70px",
                height: "auto",
                maxHeight: "35px",
                objectFit: "contain",
                filter: "brightness(1.1) contrast(1.1)",
              }}
            />
          </div>
        </Box>
      </button>
    </FreeTrialLock>
  );
};

export default RedesignLifeButton;
